import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import VisibilitySensor from 'react-visibility-sensor';
import styles from './ContentVideo.css';

class ContentVideo extends Component {
  static propTypes = {
    pic: PropTypes.object.isRequired,
    url: PropTypes.string.isRequired,
  };

  state = {
    isVisible: false,
  }

  onChange(isVisible) {
    if (!this.state.isVisible && isVisible) {
      this.setState({
        isVisible: isVisible,
      });
    }
  }

  render() {
    const { pic, url } = this.props;
    const { isVisible } = this.state;

    return (
      <div className={styles.video}>
        <VisibilitySensor
          onChange={this.onChange.bind(this)}
          partialVisibility={true}
        >
          <video loop autoPlay playsInline controls={pic.videoControl} muted name={pic.engTitle}
            className={classnames(styles.content, { 'animated fadeInUp': isVisible })}>
            <source src={url} type="video/mp4" />
          </video>
        </VisibilitySensor>
      </div>
    );
  }
}

export default ContentVideo;



// WEBPACK FOOTER //
// ./src/components/content-video/ContentVideo.js